<template>
  <li class="nav-item active">
    <router-link class="nav-link" :to="to">
      <div
        v-if="$slots.icon"
        class="text-center d-flex align-items-center justify-content-center me-2"
      >
        <slot name="icon"></slot>
      </div>
      <span v-if="miniIcon" class="sidenav-mini-icon"> {{ miniIcon }} </span>
      <span class="nav-link-text ms-1">{{ text }}</span>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "SidenavItem",
  props: {
    to: {
      type: [Object, String],
      required: true
    },
    miniIcon: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>
